import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MagentoProduct } from '../../models';
import { TmsWebBaseService } from '../base';

@Injectable({
  providedIn: 'root',
})
export class ProductMagentoService extends TmsWebBaseService {
  constructor() {
    super('ProductMagento');
  }

  getProduct(): Observable<MagentoProduct[]> {
    return this.httpService.get<MagentoProduct[]>(`${this.apiUrl}/GetProducts`);
  }

  getImportProducts(): Observable<MagentoProduct[]> {
    return this.httpService.post<MagentoProduct[]>(`${this.apiUrl}/ImportProductStock`, {});
  }

  getWebsiteProductLink(): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateWebsiteProductLink`, {});
  }
}
